module.exports = __webpack_public_path__ + "img/PrintActive.d1ab6adc.svg";